export default {
    ATIVO: 'Ativo',
    INATIVO: 'Inativo'
}